/**
 * @generated SignedSource<<2bc6b9d83961b7d03d1d9aa6359abdd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentProcessor = "BRAINTREE" | "KLARNA" | "OFF_PLATFORM" | "STRIPE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentStepCreditCardList_buyer$data = {
  readonly serviceId: string | null;
  readonly wallet: {
    readonly paymentMethods: ReadonlyArray<{
      readonly paymentMethod: {
        readonly __typename: "CreditCard";
        readonly cardExpiryMonth: string | null;
        readonly cardExpiryYear: string | null;
        readonly cardLogo: string | null;
        readonly cardType: string | null;
        readonly formattedTextMaskedCardNumber: string | null;
        readonly hashedCardNumber: string | null;
        readonly paymentProcessor: PaymentProcessor | null;
        readonly token: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "CheckoutPaymentStepCreditCardList_buyer";
};
export type CheckoutPaymentStepCreditCardList_buyer$key = {
  readonly " $data"?: CheckoutPaymentStepCreditCardList_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentStepCreditCardList_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentStepCreditCardList_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Wallet",
      "kind": "LinkedField",
      "name": "wallet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WalletPaymentMethod",
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "token",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cardLogo",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cardType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cardExpiryMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cardExpiryYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "formattedTextMaskedCardNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hashedCardNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "paymentProcessor",
                      "storageKey": null
                    }
                  ],
                  "type": "CreditCard",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5fc588ca636ba8e8c98fa2f618dd3577";

export default node;
